import React, { useRef, useMemo } from 'react';
import { useFrame } from '@react-three/fiber';
import * as THREE from 'three';
import { ZONES } from '../config/zones';
import { mulberry32 } from './rng';
import { shared } from './shared';
import { useStore } from '../store';

const dummy = new THREE.Object3D();
const HIVES = ZONES.map((z) => new THREE.Vector3(z.x, 0, -60)); // Research Hubs on the Liberal bank
const LEN = 34; // march length from bank edge up to the hub
const START_Z = -94;
const SPEED = 3.2;

// Hive Mind: leafcutter ants march in perfectly synchronized single-file columns
// toward the Progressive Research Hubs.
export default function Ants() {
  const ref = useRef();
  const q = typeof window !== 'undefined' && (new URLSearchParams(window.location.search).get('photo') || new URLSearchParams(window.location.search).get('lowfx') === '1') ? 0.3 : 1;
  const COUNT = Math.round(300 * q);

  const ants = useMemo(() => {
    const rand = mulberry32(9182 + useStore.getState().worldSeed);
    return Array.from({ length: COUNT }).map((_, i) => {
      const hub = HIVES[i % HIVES.length];
      const lane = Math.floor(i / HIVES.length) % 5;
      return {
        hubX: hub.x,
        laneX: hub.x + (lane - 2) * 0.8, // parallel files
        order: (i * 1.15) % LEN,          // fixed spacing along the column
        y: 0.28 + (rand() * 0.06),
      };
    });
  }, []);

  useFrame((state) => {
    if (!ref.current) return;
    const march = (state.clock.elapsedTime * SPEED) % LEN; // one shared cadence = synchronized
    for (let i = 0; i < COUNT; i++) {
      const a = ants[i];
      const p = (march + a.order) % LEN;
      dummy.position.set(a.laneX, a.y, START_Z + p);
      dummy.rotation.set(0, 0, 0); // all face the hub (+z)
      dummy.scale.set(0.5, 0.3, 1.1);
      dummy.updateMatrix();
      ref.current.setMatrixAt(i, dummy.matrix);
    }
    ref.current.instanceMatrix.needsUpdate = true;
  });

  return (
    <instancedMesh ref={ref} args={[undefined, undefined, COUNT]} frustumCulled={false}>
      <boxGeometry args={[0.4, 0.4, 0.4]} />
      <meshStandardMaterial color="#1b120c" emissive="#2fe6a8" emissiveIntensity={0.5} flatShading />
    </instancedMesh>
  );
}
